import { render, staticRenderFns } from "./ItemAccordionQuestion.vue?vue&type=template&id=54d7ec3f"
import script from "./ItemAccordionQuestion.vue?vue&type=script&lang=js"
export * from "./ItemAccordionQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports